class Field {
    description= "";
    id=null;
    type= ""; //Think about this on future
    object ="quote"; //quote, user , project. 
    default = false;

    constructor(){

    }
}

export default Field;
